import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PISparePartModel } from '../../models/pi-spare-part.model';
import { faChevronDown, faChevronUp, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { ColumnModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-pi-spare-part-expandable',
    templateUrl: './pi-spare-part-expandable.component.html',
    styleUrls: ['./pi-spare-part-expandable.component.scss'],
    standalone: false,
})
export class PiSparePartExpandableComponent implements OnInit {
    @Input() public parentForm: FormArray;
    @Input() public row: PISparePartModel;
    @Input() public columns: ColumnModel[];

    @Output() public deleteRow = new EventEmitter();
    @Output() public quantityChange = new EventEmitter<AbstractControl>();

    protected readonly faChevronDown = faChevronDown;
    protected readonly faChevronUp = faChevronUp;
    protected readonly faTrashAlt = faTrashAlt;
    public isCollapsed = false;
    public formChildren: FormArray;
    public pISparePartExpandableForm: FormGroup;

    public constructor(private formBuilder: FormBuilder) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.pISparePartExpandableForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.parentForm.push(this.pISparePartExpandableForm);
    }

    public deleteSparePartRow(): void {
        this.deleteRow.emit();
    }

    public updateQuantityValidation(quantity: number): void {
        if (quantity <= this.row.quantity.options.maxValue) {
            this.quantityChange.emit(this.pISparePartExpandableForm);
        }
    }

    public get(field: string): string {
        return _.get(this.row, field);
    }
}
